<template>
    <div class="cj-page">
        <m-header></m-header>
        <div class="hd-content flex flex-direction align-center">
            <div class="zp-box flex justify-center align-center">
                <div class="prize-zone">
                    <div class="prize" v-for="(item,index) in prizeList" :key="index">
                        <div class="content">
                            <div class="img">
                                <img :src="linkAllImgUrl(item.img)" />
                                <div class="prize-name">{{item.name}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <img class="pointer-img" src="../assets/gfMoney/zp-point.png" @click="start()">

            </div>
            <div class="chance-times">剩余{{times}}次抽奖机会</div>
            <div class="introduce" @click="showIntroduce = true">每邀请1，5，10位好友时获取抽奖机会 <span style="display: inline-block;margin-left: 20px;cursor: pointer"><i class="el-icon-warning-outline" style="margin-right: 5px"></i>活动说明</span></div>
            <div class="record-box">
                <div class="record-top flex align-center justify-between">
                    <div style="cursor: pointer">中奖记录</div>
                    <div style="cursor: pointer;color: red"  @click="showMyRecord">我的奖品</div>
                </div>
                <div class="record-list">
                    <div class="record-item flex align-center justify-between" v-for="(item,index) in zjList" :key="index">
                        <div class="flex align-center">
                            <img src="../assets/gfMoney/prize-icon.png" style="width: 21px;height: 24px;">
                            <div style="margin-left: 20px">恭喜用户 <span style="color: red;display: inline-block;width: 130px">{{hiddenStr(item.fullName)}}</span> 抽到 <span style="color: red;">{{item.name}}</span></div>
                        </div>
                        <div>{{moment(item.createTime).format('yyyy-MM-DD HH:mm')}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mask flex align-center justify-center" v-if="showMask" @click="showMask = false">
            <div class="modal">
                <div class="modal-title-box flex align-center justify-center">
                    <div>恭喜您中奖啦!</div>
                    <i class="el-icon-close close-icon" @click="showMask = false"></i>
                </div>
                <div class="modal-content flex flex-direction align-center" @click.stop="">
                    <img class="prize-img" :src="linkAllImgUrl(prinzInfo.img)" />
                    <div class="prize-label">{{prinzInfo.name}}</div>
                    <div class="modal-confirm" @click="showMask = false">确定</div>
                </div>
            </div>
        </div>
        <div class="mask flex align-center justify-center" v-if="showIntroduce" @click="showIntroduce = false">
            <div class="modal" style="width: 800px;background-color: #ECDFE1">
                <div class="modal-title-box flex align-center justify-center">
                    <div>活动说明!</div>
                    <i class="el-icon-close close-icon" @click="showIntroduce = false"></i>
                </div>
                <div class="modal-content " style="padding: 20px 30px;" @click.stop="">
                    <div class="modal-text">抽奖概率</div>
                    <div class="modal-box flex flex-wrap align-center">
                        <div v-for="(item,index) in prizeList" :key="index" class="k-item">
                            <span style="color: #363636;display: inline-block;width: 80px;position: relative;top: 5px;" class="text-line-1">{{item.name}}</span>
                            <span style="color: #F85D5B">{{item.percent}}%</span>
                        </div>
                    </div>
                    <div class="modal-text" style="margin-top: 20px">抽奖说明</div>
                    <div class="modal-box" v-html="activityInfo.luckyRule"></div>
                </div>
            </div>
        </div>
        <div class="mask flex align-center justify-center" v-if="showRecord" @click="showRecord = false">
            <div class="modal" style="width: 1000px;">
                <div class="modal-title-box flex align-center justify-center">
                    <div>我的中奖记录</div>
                    <i class="el-icon-close close-icon" @click="showRecord = false"></i>
                </div>
                <div class="modal-content " style="padding: 20px 30px;" @click.stop="">
                    <div class="record-list">
                        <div class="record-item flex align-center justify-between" v-for="(item,index) in myPrizeList" :key="index">
                            <div class="flex align-center">
                                <img src="../assets/gfMoney/prize-icon.png" style="width: 21px;height: 24px;">
                                <div style="margin-left: 20px;width: 300px;"> 获得奖品 <span style="color: red;">{{item.name}}</span></div>
                                <div style="color: #999999">{{moment(item.createTime).format('yyyy-MM-DD HH:mm')}}</div>
                            </div>
                            <div v-if="item.state === 1" style="color: #999999;width: 120px;text-align: center">已领取</div>
                            <div v-if="item.state === 0" class="getPrize" @click="getPrize(item.id)">立即领取</div>
                        </div>
                    </div>
                    <el-pagination style="text-align: right;margin-top: 30px" @current-change="sizeChange"
                            layout="prev, pager, next"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>

        <div class="mask flex align-center justify-center" v-if="showForm">
            <div class="modal">
                <div class="modal-title-box flex align-center justify-center">
                    <div>实物奖品请填写收货地址!</div>
                    <i class="el-icon-close close-icon" @click="showForm = false"></i>
                </div>
                <div class="modal-content flex flex-direction align-center" @click.stop="" style="padding: 30px">
                    <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="80px" label-position="left" style="width: 100%;">
                        <el-form-item label="收货人" prop="linkMan">
                            <el-input v-model="formData.linkMan" placeholder="请填写收货人" style="width: 100%"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话" prop="linkPhone">
                            <el-input v-model="formData.linkPhone" maxLength="11" placeholder="请填写联系电话" style="width: 100%"></el-input>
                        </el-form-item>
                        <el-form-item label="收货地址" prop="address">
                            <el-input type="textarea" :rows="5" v-model="formData.address" placeholder="请填写收货地址" style="width: 100%"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="confirm-info">
                        <el-checkbox label v-model="isChecked" style="margin-right: 5px;"></el-checkbox>
                        <span class="confirm-info-before-text">已阅读并同意</span>
                        <a :style="{ cursor: 'pointer' }" @click="dialogTableVisible = true"
                           class="confirm-info__info">《用户服务条款》</a>
                    </div>
                    <div class="prize-confirm" @click="submit">确定</div>
                </div>
            </div>
        </div>
        <el-dialog :width="1000" :visible.sync="dialogTableVisible" title="请您仔细阅读以下内容" :close-on-click-modal="false"
                   :close-on-press-escape="false">
            <div class="protocol-home">
                <el-main class="protocolPrivacy">
                    <m-userPro></m-userPro>
                </el-main>
            </div>
            <div class="closeButton flex align-center justify-center">
                <el-button type="primary" @click="agreeProtocol">我已阅读并同意以上协议 </el-button>
            </div>
        </el-dialog>
        <m-footer></m-footer>
    </div>
</template>

<script>
    import { getBannerApi } from "@/api/user";
    import {
      getPrizeListApi,
      getLuckyTimesApi,
      luckyStartApi,
      getLatestRecordApi,
      getPrizeRecordApi,
      getPrizeApi,
      getActivityInfo
    } from "@/api/activity";
    let retry = false
    import commonMixin from "@/mixins/commonMixin";
    import moment from 'moment'
    let interval = null
    export default {
        mixins: [commonMixin],
        data(){
            return {
              activityInfo:{},
                prizeList: [],
                times: 0,
                prinzInfo: {},
                showMask: false,
                startState: true,
                zjList: [],
                showIntroduce: false,
                showRecord: false,
                myPrizeList: [],
                total:0,
                pageNum: 1,
                showForm: false,
                formData:{
                    linkMan:'',
                    linkPhone:'',
                    address:''
                },
                isChecked: false,
                rules: {
                    linkMan: [
                        { required: true, message: '请填写收货人', trigger: 'blur' }
                    ],
                    linkPhone: [
                        { required: true, message: '请填写联系电话', trigger: 'blur' },
                      {
                        pattern: /^[1-9][0-9]{10}$/,
                        message: "请输入正确的手机号",
                        trigger: "blur",
                      },
                    ],
                    address: [
                        { required: true, message: '请填写收货地址', trigger: 'blur' }
                    ]
                },
                dialogTableVisible: false,
            }
        },
        async mounted(){
          this.getActivity()
            await this.getPrizeList()
            this.getTimes()

            this.getZjList()
            interval = setInterval(()=>{
                this.getZjList()
            },60000)

            // 每一个奖品的变换
            let prizeList = document.querySelectorAll('.prize');
            let pLen = prizeList.length;
            let pRotateStep = 360/pLen;
            let halfOfPRotateStep = pRotateStep/2;
            prizeList.forEach(function(item,index){
                item.style.transform="rotate("+(pRotateStep*(index+1))+"deg"+") skewY("+pRotateStep+"deg)";
                item.style.transformOrigin="right bottom";
            });
            // 奖品的内容变换
            let contentList = document.querySelectorAll('.content');
            contentList.forEach(function(item){
                // 反向变换，用于抵消div.prize的变形 这里的translate值，其实可以用三角函数算出来，但是太复杂，我就用肉眼观测取了7px 100px这么个值
                item.style.transform = "skewY(-"+pRotateStep+"deg) rotate(-"+halfOfPRotateStep+"deg) translate(7px, 100px)";
                item.style.transformOrigin = "center center";
            });

            // 监听动画完成事件
            document.querySelector('.prize-zone').addEventListener('transitionend',function(){
                retry = true;
            });
        },
        methods: {
            moment,
            getActivity(){
              getActivityInfo().then(res=>{
                this.activityInfo = res.data
              })
            },
            submit(){
                if (!this.isChecked) {
                    this.$message.error("请阅读并同意相关协议");
                    return false;
                }
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        getPrizeApi(this.formData).then(res=>{
                            this.showForm = false
                            this.getMyPrizeList()
                            if (res.code === 200) {
                                this.$message.success("已领取，发货中...");
                            } else {
                                this.$message.error("领取失败！");
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            // 对话框
            agreeProtocol() {
                if (this.dialogTableVisible) {
                    this.dialogTableVisible = false;
                    this.isChecked = true;
                } else {
                    this.dialogTableVisible = false;
                }
            },
            getPrize(id){
                this.formData.recordId = id
              this.showForm =true
            },
            hiddenStr(name){
              let newStr;
              if (name.length === 2) {
                newStr = name.substr(0, 1) + '*';
              } else if (name.length > 2) {
                let char = '';
                for (let i = 0, len = name.length - 2; i < len; i++) {
                  char += '*';
                }
                newStr = name.substr(0, 1) + char + name.substr(-1, 1);
              } else {
                newStr = name;
              }
              return newStr;
            },
            getZjList(){
                getLatestRecordApi().then(res=>{
                    this.zjList = res.data
                })
            },
            sizeChange(e){
              this.pageNum = e
              this.getMyPrizeList()
            },
            showMyRecord(){
              this.showRecord = true
                this.getMyPrizeList()
            },
            getMyPrizeList(){
                getPrizeRecordApi({pageNum:this.pageNum,pageSize:5}).then(res=>{
                    this.myPrizeList = res.data.list
                    this.total = res.data.total
                })
            },
            show(){
                this.$alert('这是一段内容', '标题名称', {
                    confirmButtonText: '确定',
                    callback: action => {
                        this.$message({
                            type: 'info',
                            message: `action: ${ action }`
                        });
                    }
                });
            },
            getTimes(){
                getLuckyTimesApi().then(res=>{
                    this.times = res.data ? res.data : 0
                })
            },
            async getPrizeList(){
                await getPrizeListApi().then(res=>{
                    this.prizeList = res.data
                    let total = 0
                    this.prizeList.forEach(item=>{
                        total += item.percentNum
                    })
                    this.prizeList.forEach(item=>{
                        item.percent = ((item.percentNum/total) * 100).toFixed(2)
                    })
                })
            },
            start(){
                // let truntable = document.querySelector('.prize-zone');
                // truntable.style.transition="all 1s ease";
                // truntable.style.transform="rotate("+70+"deg)";
                // return
              if (!this.startState) {
                return
              }
                if(this.times <= 0) {
                    this.$message({
                        type: 'info',
                        message: `暂无抽奖机会`
                    });
                    return
                }
                this.times --
                this.startState = false
                luckyStartApi().then(res=>{
                    this.prinzInfo = res.data
                    let truntable = document.querySelector('.prize-zone');
                    truntable.style.transition="all 10s ease";
                    truntable.style.transform="rotate("+res.data.deg+"deg)";
                    this.getTimes()
                    setTimeout(()=>{
                        this.showMask = true
                        this.startState = true
                        this.clear();
                    },10500)
                })
                // if(retry){
                //     retry = false;
                //     this.clear();
                //     return;
                // }
                // // 计算一个随机的度数，转起来，先转上十圈然后再转一圈内的随机度数
                // let deg1=360*10;
                // let deg2 = (Math.floor(Math.random()*8)+1)*45+22.5;
                // let deg=deg1+deg2;
                // let truntable = document.querySelector('.prize-zone');
                // truntable.style.transition="all 10s ease";
                // truntable.style.transform="rotate("+deg+"deg)";
            },
            clear(){
                let truntable = document.querySelector('.prize-zone');
                truntable.style.transition="none";
                truntable.style.transform="none";
            }
        },
        destroyed() {
            interval.remove()
        }
    }
</script>

<style lang="less" scoped>
    .cj-page {
      min-width: 1200px;
    }
    .k-item {
        width: 33%;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
    }
    .prize-confirm {
        margin-top: 20px;
        width: 200px;
        height: 40px;
        background: #FA5C5C;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
    }
    .confirm-info {
        padding: 20px 0 15px;
        font-size: 12px;
        line-height: 20px;
        outline: none;
        color: #999;

        .confirm-info__info {
            text-decoration: underline;
            color: rgb(255, 0, 0);
            margin: 0 6px;
        }
    }
    .getPrize {
        width: 120px;
        height: 40px;
        background: #FA5C5C;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
        cursor: pointer;
    }
    div {
        box-sizing: border-box;
    }
    .modal-text {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FF4F6C;
    }
    .modal-box {
        width: 743px;
        height: 140px;
        background: #FFFFFF;
        border-radius: 20px;
        padding: 20px;
        margin-top: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #363636;
        line-height: 20px;
        overflow: auto;
    }
    .record-list {
        .record-item {
            height: 60px;
        }
    }
    .mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        background-color: rgba(#000000,0.4);
        .modal {
            width: 580px;
            height: 537px;
            background: #FFFFFF;
            border-radius: 20px;
            position: relative;
            .modal-content {
                .prize-img {
                    width: 160px;
                    height: 160px;
                    margin-top: 45px;
                }
                .prize-label {
                    margin-top: 45px;
                    font-size: 20px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #363636;
                }
                .modal-confirm {
                    margin-top: 57px;
                    width: 200px;
                    height: 60px;
                    background: #FA5C5C;
                    font-size: 20px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 60px;
                    text-align: center;
                    cursor: pointer;
                }
            }
            .modal-title-box {
                width: 100%;
                height: 90px;
                position: relative;
                background: linear-gradient(90deg, #FF99AA 0%, #FF4F6C 100%);
                border-radius: 20px 20px 0px 0px;
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
                .close-icon {
                    position: absolute;
                    right: 20px;
                    top: 30px;
                    font-size: 30px;
                    cursor: pointer;
                }
            }
        }
    }
    .message-box {
        overflow: hidden;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
    }
    .prize-name {
        position: relative;
        top: 90px;
        width: 80px;
        text-align: center;
        font-size: 10px;
        color: #feff08;
    }
    .prize-zone {
        position: relative;
        left: 2px;
        height: 460px;
        width: 460px;
        background-color: #b7b7b7;
        border-radius: 50%;
        overflow: hidden;
    }
    .prize{
        width:230px;
        height:230px;
        position:absolute;
        left:0;
        top:0;
    }
    .prize:nth-child(2n) {
        background-color: #F3AFCA;
    }
    .prize:nth-child(2n + 1) {
        background-color: #FEDAD5;
    }
    .content{
        width:200px;
        height:250px;
        position:absolute;
        right:0;
        bottom:0;
        text-align: center;
    }
    .content .thanks{
        width:34px;
        height: 150px;
        font-size:30px;
        font-weight: bolder;
        color: #ff6e37;
        margin:0 auto;
        line-height: 34px;
        padding-top:20px;
    }
    .content .img{
        width:10px;
        height:10px;
        position: absolute;
        left:50%;
        margin-left:-46px;
        top:25%;
    }
    .content img{
        width:80px;
        height:80px;
        position: absolute;
    }

    .record-box {
        margin-top: 84px;
        width: 1000px;
        min-height: 330px;
        background: #FFFFFF;
        border-radius: 20px;
        padding: 22px;
        .record-top {
            height: 75px;
            width: 100%;
            border-bottom: 1px solid #EEEEEE;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #4D4D4D;
        }
    }
    .introduce {
        margin-top: 33px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
    }
    .chance-times {
        margin-top: 72px;
        font-size: 36px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
    }
    .hd-content {
        width: 100%;
        height: 2000px;
        background-image: url("../assets/gfMoney/lunpan_back.png");
        background-size: 100% 2000px;
        background-repeat: no-repeat;
        position: relative;
    }
    .zp-box {
        margin-top: 200px;
        width: 530px;
        height: 530px;
        background-image: url("../assets/gfMoney/zp-circle.jpg");
        background-size: 531px 531px;
        background-repeat: no-repeat;
        position: relative;
        border-radius: 50%;
        .pie-map {
            width: 400px;
            height: 400px;
        }
    }
    .pointer-img {
        position: absolute;
        left: 207px;
        top: 147px;
        width: 120px;
        height: 174px;
        cursor: pointer;
    }
    @keyframes xz {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(3700deg);
        }
    }
    @-webkit-keyframes  xz {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(3700deg);
        }
    }
</style>
